var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" },
          [
            _c(
              "c-table",
              {
                attrs: {
                  title: "LBL0001952",
                  columns: _vm.grid.columns,
                  gridHeight: _vm.grid.height,
                  data: _vm.grid.data,
                  filtering: false,
                  columnSetting: false,
                  usePaging: false,
                  editable: _vm.editable && !_vm.disabled,
                },
              },
              [
                _c(
                  "template",
                  { slot: "table-button" },
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _vm.editable && !_vm.disabled
                          ? _c("c-btn", {
                              attrs: {
                                isSubmit: _vm.isSaveComitteeHold,
                                url: _vm.saveComitteeHoldUrl,
                                param: _vm.moc,
                                mappingType: "PUT",
                                label: "LBLSAVE",
                                icon: "save",
                              },
                              on: {
                                beforeAction: _vm.saveComitteeHold,
                                btnCallback: _vm.saveComitteeHoldCallback,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          1
        ),
        Boolean(_vm.moc.committeeHold)
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" },
              [
                _c(
                  "c-card",
                  {
                    attrs: {
                      title: "LBL0002031",
                      disabled: !_vm.approvalEditable,
                    },
                  },
                  [
                    _c(
                      "template",
                      { slot: "card-button" },
                      [
                        _c(
                          "q-btn-group",
                          { attrs: { outline: "" } },
                          [
                            _c(
                              "q-chip",
                              {
                                staticClass: "no-border",
                                staticStyle: {
                                  "margin-right": "5px !important",
                                },
                                attrs: {
                                  square: "",
                                  outline: "",
                                  color: "red",
                                  "text-color": "white",
                                  icon: "report",
                                  size: "12px",
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$label("LBL0002040")) + "  "
                                ),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.$label("LBL0002041"))),
                                ]),
                                _vm._v(
                                  " " + _vm._s(_vm.$label("LBL0002042")) + " "
                                ),
                              ]
                            ),
                            _vm.editable && !_vm.disabled
                              ? _c("c-btn", {
                                  attrs: {
                                    isSubmit: _vm.isSaveKeep,
                                    url: _vm.keepComitteeHoldUrl,
                                    param: _vm.moc,
                                    mappingType: "PUT",
                                    label: "LBL0002033",
                                    icon: "approval",
                                  },
                                  on: {
                                    beforeAction: _vm.keepComitteeHold,
                                    btnCallback: _vm.keepComitteeHoldCallback,
                                  },
                                })
                              : _vm._e(),
                            _vm.editable && !_vm.disabled
                              ? _c("c-btn", {
                                  attrs: {
                                    isSubmit: _vm.isSaveNonKeep,
                                    url: _vm.keepComitteeHoldUrl,
                                    param: _vm.moc,
                                    mappingType: "PUT",
                                    label: "LBL0002034",
                                    icon: "do_not_disturb_on",
                                  },
                                  on: {
                                    beforeAction: _vm.nonKeepComitteeHold,
                                    btnCallback:
                                      _vm.nonKeepComitteeHoldCallback,
                                  },
                                })
                              : _vm._e(),
                            _vm.editable && !_vm.disabled
                              ? _c("c-btn", {
                                  attrs: {
                                    isSubmit:
                                      _vm.isSaveComitteeHoldApprovalInfo,
                                    url: _vm.saveComitteeHoldUrl,
                                    param: _vm.moc,
                                    mappingType: "PUT",
                                    label: "LBLSAVE",
                                    icon: "save",
                                  },
                                  on: {
                                    beforeAction:
                                      _vm.saveComitteeHoldApprovalInfo,
                                    btnCallback:
                                      _vm.saveComitteeHoldApprovalInfoCallback,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("template", { slot: "card-detail" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                        },
                        [
                          _c("c-radio", {
                            attrs: {
                              disabled: true,
                              editable: _vm.editable,
                              comboItems: _vm.keepItems,
                              label: "LBL0002035",
                              name: "changeKeepFlag",
                            },
                            model: {
                              value: _vm.moc.committeeHold.changeKeepFlag,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.moc.committeeHold,
                                  "changeKeepFlag",
                                  $$v
                                )
                              },
                              expression: "moc.committeeHold.changeKeepFlag",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                        },
                        [
                          _c("c-datepicker", {
                            attrs: {
                              disabled: true,
                              editable: _vm.editable,
                              label: "LBL0002036",
                              name: "changeApprovalDate",
                            },
                            model: {
                              value: _vm.moc.committeeHold.changeApprovalDate,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.moc.committeeHold,
                                  "changeApprovalDate",
                                  $$v
                                )
                              },
                              expression:
                                "moc.committeeHold.changeApprovalDate",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                        },
                        [
                          _c("c-textarea", {
                            attrs: {
                              disabled: _vm.disabled,
                              editable: _vm.editable,
                              label: "LBL0002037",
                              name: "changeKeepReason",
                            },
                            model: {
                              value: _vm.moc.committeeHold.changeKeepReason,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.moc.committeeHold,
                                  "changeKeepReason",
                                  $$v
                                )
                              },
                              expression: "moc.committeeHold.changeKeepReason",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-sm-12 col-md-12 col-lg-12 col-xl-12",
                        },
                        [
                          _c("c-upload", {
                            attrs: {
                              attachInfo: _vm.attachInfo,
                              editable:
                                _vm.editable &&
                                !_vm.disabled &&
                                _vm.approvalEditable,
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c(
        "c-table",
        {
          staticClass: "q-mt-sm",
          attrs: {
            title: "LBL0001959",
            columns: _vm.grid3.columns,
            gridHeight: _vm.grid3.height,
            data: _vm.moc.relatedWorks,
            filtering: false,
            usePaging: false,
            columnSetting: false,
            editable: _vm.editable && !_vm.disabled,
          },
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _vm.editable && !_vm.disabled
                    ? _c("c-btn", {
                        attrs: {
                          isSubmit: _vm.isSaveRelatedWork,
                          url: _vm.saveRelatedWorkUrl,
                          param: _vm.grid3.saveData,
                          mappingType: "PUT",
                          label: "LBLSAVE",
                          icon: "save",
                        },
                        on: {
                          beforeAction: _vm.saveRelatedWork,
                          btnCallback: _vm.saveRelatedWorkCallback,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "c-table",
        {
          staticClass: "q-mt-sm",
          attrs: {
            title: "LBL0001960",
            columns: _vm.grid2.columns,
            gridHeight: _vm.grid2.height,
            data: _vm.moc.committeeReviewItems,
            filtering: false,
            columnSetting: false,
            usePaging: false,
            editable: _vm.editable && !_vm.disabled,
          },
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _vm.editable && !_vm.disabled
                    ? _c("c-btn", {
                        attrs: {
                          isSubmit: _vm.isSaveReviewItem,
                          url: _vm.saveReviewItemUrl,
                          param: _vm.grid2.saveData,
                          mappingType: "PUT",
                          label: "LBLSAVE",
                          icon: "save",
                        },
                        on: {
                          beforeAction: _vm.saveReviewItem,
                          btnCallback: _vm.saveReviewItemCallback,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }